<template>
  <v-text-field
    outlined
    v-bind="$attrs"
    :rules="rules"
    :value="value" 
    v-on="on"
    @click:append-outer="$emit('appendOuterIconClick')"
    @input="v => $emit('input', v)"
    @blur="v => $emit('blur', v)"
    @wheel.prevent
    >
  </v-text-field>
</template>

<script>
export default {
  name: 'EsTextField',
  props: {
    value: [String, Number],
    required: Boolean,
    maxLength: Number,
    on: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data: () => ({
    requiredRule: (v) => !!v || 'Required',
  }),
  computed: {
    maxLengthRule() {
      return (v) => (v?.length || 0) <= this.maxLength || `Max ${this.maxLength} characters`;
    },
    rules() {
      let rules = [];
      if (this.required) {
        rules.push(this.requiredRule);
      }
      if (this.maxLength) {
        rules.push(this.maxLengthRule);
      }
      return rules;
    },
  },
};
</script>
